import React from 'react'

import classNames from 'classnames'

import { CommonSmallHorizontalArrowIcon } from '@local/assets/icons'

import Clickable from '@web/components/Clickable'
import { LANExposureArea } from '@web/components/LANBanner/LANBanner.constant'
import useGetExposureNotifications from '@web/hooks/useGetExposureNotifications'

import styles from './banner.module.scss'

interface Props {
  nClickCode?: string
}

export default function BannerBestReviewer({ nClickCode }: Props) {
  const {
    notifications: [banner],
  } = useGetExposureNotifications(LANExposureArea.MISSION_GOOD_REVIEWER)

  if (!banner) return null

  return (
    <div className={classNames(styles.banner_area, styles.type_best_reviewer)}>
      <div className={styles.tit_area}>{banner.title}</div>
      <div className={styles.btn_area}>
        <Clickable className={styles.btn} href={banner.linkUrl ?? undefined} nClickCode={banner.clickCode}>
          {banner.description}
          <CommonSmallHorizontalArrowIcon className={styles.icon} aria-hidden="true" />
        </Clickable>
      </div>
    </div>
  )
}
